mutation AddRateComponent($input: RateComponentInput!) {
    createRateComponent(input: $input) {
        payload {
            id
            name
            code

        }
        messages {
            field
            message
            severity
        }
        result
    }
}
mutation EditRateComponent($id: ID!, $input: RateComponentInput!) {
    editRateComponent(id: $id, input: $input) {
        messages {
            field
            message
            severity
        }
        result
    }
}

mutation DeleteRateComponent($id: ID!) {
    deleteRateComponent(id: $id) {
        result
        messages {
            field
            message
            severity
        }
    }
}

query RateComponent($id: ID!) {
    rateComponent(id: $id) {
        id
        name
        code
        description
        archived
        ratelists {
            id
            name
        }
    }
}
